import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import EmptyState from './icons/EmptyState'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const useStyles = makeStyles({
  container: {
    padding: '0px 20px 0px 20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const NotesEmptyState = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <EmptyState />
      <DazzedParagraph14
        style={{ color: 'var(--text-color-11)', whiteSpace: 'pre-line', textAlign: 'center', lineHeight: '22px' }}
      >
        {t('pages.patients.patientSwitchableView.notes.noNotes')}
      </DazzedParagraph14>
    </div>
  )
}

export default NotesEmptyState
